// import Cookies from "js/js-cookie.js";
// import { Cookies} from 'js/js-cookie.js';
   // alert("Script loaded but not necessarily executed.");


var jobid = null;
// use this if we want detalje errorreport
var testtabellprefix = null;
var token = Cookies.get('token');
var userCookie = Cookies.get('user');
var userName = Cookies.get("userName");
var userFirm = Cookies.get("userFirm");

$.ajaxSetup({
  cache: false
});

// console.log('start upload: ' + token);
if (!token) {
  window.location.href = 'login.html';
}

$(function() {
  $('#sbaseSpinner').removeClass('spinner');
  $('#controlButton').prop('disabled', true);
  if (userCookie && token) {
    user = userCookie;
    $('#userLoggedin').text(user);
    $('#userId').text(user);
    $('#userFirm').text(userFirm);
    $('#userName').text(userName);
  }

  $('#saveButton').prop('disabled', true);

  // $('button[type=submit]').click(function(e) {
  $('#controlButton').click(function(e) {
    e.preventDefault();
    //Disable submit button
    $(this).prop('disabled', true);



    var form = document.forms[0];
    var formData = new FormData(form);
    $('#file').filestyle({
      disabled: true
    });

    // Ajax call for file uploaling
    var ajaxReq = $.ajax({
      url: '/s2mis_ws/upload',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,

      xhrFields: {
        withCredentials: true
      },
      beforeSend: function(xhr) {
        $('#alertMsg').text('Laster opp fil og kontrollerer...');
        $('#alertMsg').css('color', '#000');
        $('#sbaseSpinner').addClass('spinner');
        xhr.setRequestHeader('Authorization', 'Basic ' + token);
        xhr.setRequestHeader('IEAuth', 'Basic ' + token);
      },
      success: function(result, textStatus, status) {
        if (status.status == 200) {
          var table4errorReport = false;
          var resTable = makeTable(result, table4errorReport);
          var errorButton = makeButton(result);

          $('#tableDiv').html(resTable);
          $('#errorButtonDiv').html(errorButton);
          $('#alertMsg').text('');
          $('#alertMsgErrorReport').text('');
          $('#controlButton').prop('disabled', true);
          $('#saveButton').prop('disabled', false);
          getDataHistory();
        } else {
          showError(result);
        }
      },
      error: function(error) {
         showError(error);
      },
      complete: function(complete) {
        var msg = complete.responseJSON;
        if(msg && msg.JobbId !== 'undefined') {
          jobid = msg.JobbId;
        }

        if (msg && typeof msg.beskrivelser !=='undefined') {
          testtabellprefix = msg.beskrivelser[0].testtabellprefix;
        }
        if (msg && msg.antall_objektfeil!=='undefined') {
            antall_objektfeil = msg.antall_objektfeil;
        }
        var status ='';
        if (msg && msg.status !=='undefined') {
          status = msg.Status || msg.status;
        }

        $('#file').prop('data-disabled', false);
        //console.log('Status: ', status)
        $('#sbaseSpinner').removeClass('spinner');
        if (status === 'Kontrollen er godkjent') {
          $('#saveButton').prop('disabled', false);
        } else {
          jobid = null;
          $('#saveButton').prop('disabled', true);
          //$('#alertMsg').text('Feil oppstod, prøv igjen!');
        }
      }
    });

  });

  $('#errorButtonDiv').click(function(e) {
    e.preventDefault();
    //Disable submit button
    $(this).prop('disabled', true);

//delete after switc to new endpoint
    var form = document.forms[0];
    var formData = new FormData(form);
    $('#file').filestyle({
      disabled: true
    });

    // Ajax call for get error on objectslevel
    if (testtabellprefix) {
    var ajaxReq = $.ajax({
      url: '/s2mis_ws/error_report?tabellprefix=' + testtabellprefix,
      type: 'GET',
      cache: false,
      contentType: false,
      processData: false,

      xhrFields: {
        withCredentials: true
      },
      beforeSend: function(xhr) {
        $('#alertMsgErrorReport').text('Henter detaljert feilrapport...');
        $('#alertMsgErrorReport').css('color', '#000');
        $('#sbaseSpinner').addClass('spinner');
        xhr.setRequestHeader('Authorization', 'Basic ' + token);
        xhr.setRequestHeader('IEAuth', 'Basic ' + token);
      },
      success: function(result, textStatus, status) {

        if (status.status == 200) {
          var table4errorReport = true;
          var data = makeTable($.parseJSON(result), table4errorReport);
          $('#tableObjectReport').html(data);
          $('#errorCloseDiv').html('<button id="close" class="btn btn-primary errorButton">X</button>');
        } else {
          $('#alertMsgErrorReport').text('');
          showError(result);
        }
      },
      error: function(error) {
         showError(error);
      },
      complete: function(complete) {
        $('#alertMsgErrorReport').text('');
        $('#getFailedObjectsReportButton').prop('disabled', true);
        $('#sbaseSpinner').removeClass('spinner');
      }
    });
  } else {
      $('#alertMsg').text('feil i testtabellprefix fra kontroll');
  }
  });

  $('#saveButton').click(function(e) {
    $('input[type=file]').val('');
    $('#alertMsg').css('color', '#000');
    $('#alertMsg').text('Lagrer data til databasen...');
    $('#saveButton').prop('disabled', true);
    e.preventDefault();
    $('#sbaseSpinner').addClass('spinner');
    if (jobid) {
      var url1 = '/s2mis_ws/save?jobbid=' + jobid;
      var url2 = '/s2mis_ws/links?jobbid=' + jobid;
      $.ajax({
        url: url1,
        success: function(result, statusText, status) {
          if (status.status == 200) {
            $.ajax({
              url: url2,
              success: function(a1, statusText, status) {
                var kildenLink = "";
                var url4html = "";
                if (result !== "Det har oppstått en feil.") {
                  kildenLink = a1.kildenLink;
                  url4html = $('<a target="_blank" href="' + kildenLink + '">Se prosjekt i Kilden </a></br>');
                }
                $('#sbaseSpinner').removeClass('spinner');
                $('#alertMsg').text(result);
                var a = document.getElementById('url4kilden');
                $(url4html).appendTo(a);
                $('#tableDiv').html('');
                $('#saveButton').prop('disabled', true);
                $('#controlButton').prop('disabled', true);
                getDataHistory();
                getDataStatistikk();
              }});


          } else {
            showError(result);
          }
        },
        error: function(error) {
          showError(error);
        }

      });
    } else {
      $('#alertMsg').text('feil i jobid fra kontroll');
    }

  });

  $('#logoutButton').click(function(e) {
    e.preventDefault();
    Cookies.set('token', '');
    window.location.href = 'login.html';
  });

  $('#errorCloseDiv').click(function(e) {
    $('#tableObjectReport').html('');
    $('#getFailedObjectsReportButton').prop('disabled', false);
    $('#errorCloseDiv').html('');
  });

  $('input[type=file]').on('change', prepareUpload);

  function prepareUpload(event) {
    $('#tableDiv').html('');
    $('#tableObjectReport').html('');
    $('#errorButtonDiv').html('');
    $('#errorCloseDiv').html('');
    $('#saveButton').prop('disabled', true);
    $('#controlButton').prop('disabled', false);
    $('#alertMsg').text('');
    $('#alertMsgErrorReport').text('');
    $('#url4kilden').text('');
  }

  function makeButton(sbaseData) {
    var status = sbaseData.status;
    var antall_objektfeil	= sbaseData.antall_feil_objekt;
    var button = "";
    if (status !== 'Kontrollen er godkjent' && antall_objektfeil && antall_objektfeil > 0) {
        button += '<button id="getFailedObjectsReportButton" class="btn btn-primary errorButton">Hent fullstendig rapport på objektnivå</button>';
    }
    return button;
  }


// "window" make function global,then history.js can us it
  window.makeTable=function(sbaseData, table4errorReport) {
    var antall_objektfeil	= "";
    var status = sbaseData.status;
    if (typeof sbaseData.antall_feil_objekt !== "undefined") {
      antall_objektfeil	= sbaseData.antall_feil_objekt;
    }

    if (typeof sbaseData.Status !== "undefined") {
      status = sbaseData.Status;
    }
    var table = $('<table class="resTable" id="result">');
    var tblHeader = "<tr>";
    if(table4errorReport) {
      tblHeader += "<th>ObjektId</th><th>UUID tekst</th><th>Filnavn</th><th>Beskrivelse</th>";
    } else {
      tblHeader += "<th>Egenskap</th> <th>Verdi</th>";
    }

    tblHeader += "</tr>";
    $(tblHeader).appendTo(table);

    if (status !== 'Kontrollen er godkjent' && !table4errorReport) {
      sbaseData = sbaseData.beskrivelser;
      var TableRow = "";
      TableRow += "<tr><td>Status</td><td class='ikke_godkjent'>" + status + "</td></tr>";
      table.append(TableRow);
    }
    else if (status !== 'Kontrollen er godkjent' && table4errorReport) {
        sbaseData = sbaseData.beskrivelser;
    }

    $.each(sbaseData, function(index, value) {
      var TableRow = "<tr>";
      if (status === 'Kontrollen er godkjent') {
        TableRow += "<td>" + index + "</td>";
        TableRow += "<td>" + value + "</td>";
      } else if (status !== 'Kontrollen er godkjent' && table4errorReport ) {
        var uuid_tekst = value.objekt_uuid_tekst|| "";
        TableRow += "<td>" + value.objektid + "</td>";
        TableRow += "<td>" + uuid_tekst + "</td>";
        TableRow += "<td>" + value.tabellnavn + "</td>";
        TableRow += "<td>" + value.feilbeskrivelse + "</td>";
      }
      else {
        TableRow += "<td>Feilbeskrivelse:</td>";
        TableRow += "<td>" + value.feilbeskrivelse + "</td>";
      }
      TableRow += "</tr>";
      table.append(TableRow);
    });

    if(antall_objektfeil) {
      table.append("<tr><td>Antall objektfeil</td><td>" + antall_objektfeil + "</td></tr>");
    }
    return table;
  };



});
